<rk-sidenav-action-wrapper
  [title]="'MEDIA.FILTERS.SHELL.TITLE' | translate"
  (cancelled)="exitPanel()"
  (actionInsteadOfCancel)="resetToDefault()"
  (submitted)="saveForm()"
  [submitText]="'MEDIA.FILTERS.SHELL.APPLY_FILTERS' | translate"
  [cancelText]="'MEDIA.FILTERS.SHELL.RESET_FILTERS' | translate"
  [showLinkForCancel]="true"
>
  <div class="main-block">
    <form [formGroup]="formFilters">
      <rk-filter-tag-input formControlName="tags"></rk-filter-tag-input>
      <rk-filter-playlist-input formControlName="inPlaylist"></rk-filter-playlist-input>
      <rk-filter-numeric-input
        formControlName="year"
        [nameHeader]="'MEDIA.FILTERS.YEAR.HEADER' | translate"
        [allText]="'MEDIA.FILTERS.YEAR.ALL' | translate"
        [equalText]="'MEDIA.FILTERS.YEAR.EQUAL' | translate"
        [notEqualText]="'MEDIA.FILTERS.YEAR.NOT_EQUAL' | translate"
        [lowerText]="'MEDIA.FILTERS.YEAR.LOWER' | translate"
        [greaterText]="'MEDIA.FILTERS.YEAR.GREATER' | translate"
        [betweenText]="'MEDIA.FILTERS.YEAR.BETWEEN' | translate"
        [notSetText]="'MEDIA.FILTERS.NUMERIC_INPUT.NOT_SET' | translate"
        [skipNotSet]="false"
      ></rk-filter-numeric-input>
      <rk-filter-numeric-input
        formControlName="playtime"
        [nameHeader]="'MEDIA.FILTERS.PLAYTIME.HEADER' | translate"
        [labelNumberInput]="'MEDIA.FILTERS.PLAYTIME.UNITS' | translate"
        [allText]="'MEDIA.FILTERS.PLAYTIME.ALL' | translate"
        [lowerText]="'MEDIA.FILTERS.PLAYTIME.LOWER' | translate"
        [greaterText]="'MEDIA.FILTERS.PLAYTIME.GREATER' | translate"
        [betweenText]="'MEDIA.FILTERS.PLAYTIME.BETWEEN' | translate"
        [skipEqual]="true"
        [skipNotEquals]="true"
      ></rk-filter-numeric-input>
      <rk-filter-numeric-input
        formControlName="createdDays"
        [nameHeader]="'MEDIA.FILTERS.CREATED_DAYS.HEADER' | translate"
        [labelNumberInput]="'MEDIA.FILTERS.CREATED_DAYS.UNIT_RELATIVE' | translate"
        [allText]="'MEDIA.FILTERS.CREATED_DAYS.ALL' | translate"
        [equalText]="'MEDIA.FILTERS.CREATED_DAYS.EQUAL' | translate"
        [lowerText]="'MEDIA.FILTERS.CREATED_DAYS.LOWER' | translate"
        [greaterText]="'MEDIA.FILTERS.CREATED_DAYS.GREATER' | translate"
        [betweenText]="'MEDIA.FILTERS.CREATED_DAYS.BETWEEN' | translate"
        [skipNotEquals]="true"
      ></rk-filter-numeric-input>
      <rk-filter-numeric-input
        formControlName="bpm"
        [nameHeader]="'MEDIA.FILTERS.BPM.HEADER' | translate"
        [labelNumberInput]="'MEDIA.FILTERS.BPM.UNITS' | translate"
        [allText]="'MEDIA.FILTERS.BPM.ALL' | translate"
        [equalText]="'MEDIA.FILTERS.BPM.EQUAL' | translate"
        [lowerText]="'MEDIA.FILTERS.BPM.LOWER' | translate"
        [greaterText]="'MEDIA.FILTERS.BPM.GREATER' | translate"
        [betweenText]="'MEDIA.FILTERS.BPM.BETWEEN' | translate"
        [notSetText]="'MEDIA.FILTERS.NUMERIC_INPUT.NOT_SET' | translate"
        [skipNotEquals]="true"
        [skipNotSet]="false"
      ></rk-filter-numeric-input>
      <rk-filter-numeric-input
        formControlName="bitrate"
        [nameHeader]="'MEDIA.FILTERS.KBPS.HEADER' | translate"
        [labelNumberInput]="'MEDIA.FILTERS.KBPS.UNITS' | translate"
        [allText]="'MEDIA.FILTERS.KBPS.ALL' | translate"
        [equalText]="'MEDIA.FILTERS.KBPS.EQUAL' | translate"
        [lowerText]="'MEDIA.FILTERS.KBPS.LOWER' | translate"
        [greaterText]="'MEDIA.FILTERS.KBPS.GREATER' | translate"
        [betweenText]="'MEDIA.FILTERS.KBPS.BETWEEN' | translate"
        [skipNotEquals]="true"
      ></rk-filter-numeric-input>
    </form>
  </div>
</rk-sidenav-action-wrapper>
<rk-santa [order]="2"></rk-santa>
